<template>
  <div class="inline-input-wrapper" :class="{'error': error}">
    <div class="inline-input" :class="{'inline-input--has-helptip': hasHelptip, 'inline-input--has-label': hasLabel}">
      <span v-if="label" class="inline-input-label">{{ label }}</span>
      <!-- <input :id="id" :name="name" :placeholder="placeholder" :type="type" :value="value" @input="$emit('input', $event.target.value)" @blur="$emit('blur')"> -->
      <select :id="id" :name="name" :value="value"
        @blur="$emit('blur')"
        @change="$emit('input', $event.target.value);$emit('change')"
        @focus="onfocus()">
        <option v-if="!value.length" selected disabled value="" v-html="placeholder"></option>
        <option v-for="option in options" :key="option.key" :value="option.key">{{option.description || option.key}}</option>
      </select>
      <tooltip-expanded-trigger v-if="hasHelptip" :expandedTipKey="helptipKey">
        <div class="inline-input-helptip">
          <i class="material-icons help" ttposition>help</i>
        </div>
      </tooltip-expanded-trigger>
      <i class="material-icons warning">warning</i>
    </div>
    <slot name="help-text"></slot>
    <slot name="errors"></slot>
  </div>
</template>

<script>
import TooltipExpandedTrigger from '@/components/shared/tooltip-expanded-trigger';

export default {
  name: 'inline-select-input',
  props: {
    value: {
      required: true
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    error: {
      type: Boolean
    },
    label: {
      type: String
    },
    helptipKey: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String
    }
  },
  components: {
    TooltipExpandedTrigger
  },
  computed: {
    hasHelptip() {
      return !!this.helptipKey;
    },
    hasLabel() {
      return !!this.label;
    }
  },
  methods: {
    onfocus() {
      this.scrollToActiveElement();
      this.$emit('focus');
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/forms/inline-select-input.vue